import { Table } from 'antd';
import { ColumnType, TableProps } from 'antd/lib/table';
import { PricingRules } from 'models/ProductCatalog';

export const PricingTableImport: React.FC<TableProps<PricingRules>> = ({ ...rest }) => {
  const columns: ColumnType<PricingRules>[] = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Condition',
      dataIndex: 'condition',
      key: 'condition'
    },
    {
      title: 'List Price',
      dataIndex: 'listPrice',
      key: 'listPrice',
      align: 'right',

      render: (value: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
    },
    {
      title: 'Discount Percentage',
      dataIndex: 'discountPercentage',
      key: 'discountPercentage',
      align: 'right',
      render: (value: number) => `${value}%`
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      align: 'right',

      render: (value: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
    },
    {
      title: 'Effective Date',
      dataIndex: 'effectiveDate',
      key: 'effectiveDate',
      align: 'right',

      render: (value: string) => new Date(value).toLocaleDateString()
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      align: 'right',

      render: (value: string) => new Date(value).toLocaleDateString()
    }
  ];

  return <Table size="small" pagination={false} columns={columns} {...rest} />;
};
